import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { AsyncSupportWebsiteNav } from '@jira/navigation-apps__horizontal-nav-csm-support-website/src/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';
import { csmHubSetupSupportWebsiteResource } from '@jira/router-resources__customer-service-common/src/csmHubSetupSupportWebsiteResource.tsx';
import { csmExperienceSupportWebsiteEditRoute } from '@jira/router-routes__help-center-settings-routes/src/csmExperienceSupportWebsiteEditRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';

import { getCsmExperiencesResources } from './getCsmExperiencesResources.tsx';
import { SupportWebsiteEditEntryPoint } from './ui/support-website-edit/SupportWebsiteEditEntryPoint.tsx';

export const csmExperienceSupportWebsiteEditRouteEntry: Route = createEntry(
	csmExperienceSupportWebsiteEditRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'customer-service.csm-experience-support-website.edit',
		layout: serviceProjectLayout,
		navigation: {
			menuId: MenuIdCustomerExperiences,
			sidebarId: SidebarIdCsmApp,
			horizontal: fg('csm_contact_us_rte') ? undefined : AsyncSupportWebsiteNav,
		},
		entryPoint() {
			return fg('csm_appification_standalone_navigation')
				? SupportWebsiteEditEntryPoint
				: notFoundPageEntrypoint;
		},
		resources: [
			...getCustomerServiceL1NavigationResources(),
			...getCsmExperiencesResources(),
			staticProjectSidebarNavigationResource,
			csmHubSetupSupportWebsiteResource,
		],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
